import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

/**
 * Role gate for nested `/admin/*` routes. Uses Outlet only (no extra Layout) — parent
 * ProtectedLayout already provides Navbar + shell.
 */
export function AdminRouteOutlet() {
  const { isAuthenticated, hasRole } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasRole('admin')) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
